import { axios, organizationIdConfig } from '../configs';
import { TCreateMessageForAll } from './messages';

export type TMessageTemplateType = 'GREETING' | 'MIGRATION' | 'NOTIFICATION';

export type TMessageTemplate = {
  id: number;
  organizationId: number;
  type: TMessageTemplateType;
  sections: TCreateMessageForAll[];
  sendToChat: boolean;
  buttonLabel?: string | null;
  createdAt: string;
  updatedAt: string;
};

export const getMessageTemplates = async (): Promise<TMessageTemplate[]> => {
  const response = await axios.get<TMessageTemplate[]>('message-templates');
  return response.data;
};

export const validateGreetingChatVideos = async (urls: string[]): Promise<void> => {
  await axios.post('message-templates/greeting/validate-videos', { urls });
};

export const upsertMessageTemplate = async (
  type: TMessageTemplateType,
  sections: TCreateMessageForAll[],
  sendToChat?: boolean,
  buttonLabel?: string,
  organizationId?: number | null,
): Promise<TMessageTemplate> => {
  const response = await axios.put<TMessageTemplate>(
    `message-templates/${type}`,
    {
      sections,
      ...(buttonLabel !== undefined ? { buttonLabel } : {}),
      ...(sendToChat !== undefined ? { sendToChat } : {}),
    },
    organizationIdConfig(organizationId),
  );
  return response.data;
};
